import React from 'react'

// component
import AlertPopup from '../../../Popup/AlertPopup'

const alertPopupExtendStyles = `
    margin: 33px auto 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
    width: unset;
    max-width: unset;
`

const ErrorNotLinkShop = ({ closePopup }) => {
    return (
        <AlertPopup
            type="ERROR"
            handleClickBtn={closePopup}
            extendStyles={alertPopupExtendStyles}
        >
            Tài khoản chưa được liên kết cửa hàng!
        </AlertPopup>
    )
}

export default ErrorNotLinkShop
